/**
 * Logo theme configuration
 * Contains styling and gradients for the SVG logo component
 */

// Extend the Theme interface to include custom logo configuration
declare module '@mui/material/styles' {
  interface Theme {
    logo: LogoTheme;
  }

  interface ThemeOptions {
    logo?: LogoTheme;
  }
}

export interface LogoTheme {
  gradients: {
    primary: {
      from: string;
      to: string;
    };
    secondary: {
      from: string;
      to: string;
    };
  };
  colors: {
    nodes: string;
    connections: string;
    signals: string;
  };
  text: {
    fontFamily: string;
    fontWeight: number;
    sizeFactor: number;
    color: string;
  };
}

export const logoThemeLight: LogoTheme = {
  gradients: {
    primary: {
      from: '#5C6F7B',
      to: '#3A4750',
    },
    secondary: {
      from: '#7A8B7F',
      to: '#546159',
    },
  },
  colors: {
    nodes: '#6B8E71',
    connections: '#8A9BA8',
    signals: '#A1B5A7',
  },
  text: {
    fontFamily: 'Roboto, sans-serif',
    fontWeight: 600,
    sizeFactor: 0.35,
    color: 'primary.main',
  },
};

export const logoThemeDark: LogoTheme = {
  gradients: {
    primary: {
      from: '#7A8D9A',
      to: '#5A6D7A',
    },
    secondary: {
      from: '#8FA094',
      to: '#6F8074',
    },
  },
  colors: {
    nodes: '#8FAE95',
    connections: '#9AADB9',
    signals: '#A9B9AE',
  },
  text: {
    fontFamily: 'Roboto, sans-serif',
    fontWeight: 600,
    sizeFactor: 0.35,
    color: 'primary.main',
  },
};

// Nordic Minimal theme logo configurations
export const nordicLogoThemeLight: LogoTheme = {
  gradients: {
    primary: {
      from: '#697A89',
      to: '#465561',
    },
    secondary: {
      from: '#8B7E74',
      to: '#625650',
    },
  },
  colors: {
    nodes: '#789F8A',
    connections: '#93A3B1',
    signals: '#B3A59B',
  },
  text: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 500,
    sizeFactor: 0.35,
    color: 'primary.main',
  },
};

export const nordicLogoThemeDark: LogoTheme = {
  gradients: {
    primary: {
      from: '#8A9BA8',
      to: '#6A7B88',
    },
    secondary: {
      from: '#A69990',
      to: '#7F7068',
    },
  },
  colors: {
    nodes: '#AAB8C2',
    connections: '#C2B3A9',
    signals: '#A1A3A6',
  },
  text: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 500,
    sizeFactor: 0.35,
    color: 'primary.main',
  },
};